module.exports = __webpack_public_path__ + "media/vue/assets/images/qr-codes/th_getapp-9248bdaf2969b3300e82ba7d6d2dd968.png";